import React from 'react';
import { handleError } from '../utils/helpers';

class ErrorBoundary extends React.Component {

  state: any;
  props: any;

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    handleError(error, 'error-boundary', 'componentDidCatch', { errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex justify-content-center">
          <h4>Oops, there is an error!</h4>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary
